window.CardShuffle = Block.extend({
    render: function() {
         var $wrapper = this.$el.closest(".CardShuffle");

        this.cardDeck = new CardDeck({wrapper: $wrapper});
        this.cardDeck.setup(this.app);
        this.cardDeck.handleLoadComplete();
        //this.cardDeck = this.app.getComponent("CardDeck");
        this.listenTo(this.cardDeck, "onSlideInCardsComplete", this.handleOnSlideComplete);
        this.listenTo(this.cardDeck, "onSlideOutCardsComplete", this.handleOnSlideOutComplete);
        this.listenTo(this.cardDeck, "onFlipCardsComplete", this.handleOnFlipCardComplete);
        this.cardDeck.slideInCards();
	},
	
	handleSuspend: function (e) {
		this.cardDeck.pause();
	},

	handleRestore: function (e) {
		this.cardDeck.resume();
	},

    handleOnSlideComplete: function() {
        this.cardDeck.enableTapToShuffle();
    },

    handleOnSlideOutComplete: function() {
        this.cardDeck.flipCard();
    },

    handleOnFlipCardComplete: function() {
        this.complete();
        this.cardDeck.removeCardDeck();
        this.app.router.next();
    },

    getData: function($xml, language) {
        var data;
        return data;
    },

    destroy: function() {
        this.cardDeck.destroy();
        this.stopListening(this.cardDeck, "onSlideInCardsComplete");
        this.stopListening(this.cardDeck, "onSlideOutCardsComplete");
        this.stopListening(this.cardDeck, "onFlipCardsComplete");
        Block.prototype.destroy.call(this);
    }
});
